import { compact } from 'lodash'
import { UserType } from '../../../types'

export default function name(user: UserType) {
  return compact([user.firstName, user.lastName]).join(' ') || user.emailAddress
}
